import { formatDate } from '@angular/common';
import { Country } from '../types/country.types';

export class WildcardSearchOperations {
  public static isMatch(object: any, propertyPaths: string[], searchInput: string, countries?: { id: number; name: string }[]): boolean {
    const searchArray = searchInput
      .toLowerCase()
      .split('*')
      .filter(e => e);

    return searchArray.every(searchTerm =>
      propertyPaths.some(propertyPath => {
        const valueToSearch = this.getPropertyValue(object, propertyPath, countries);
        return valueToSearch && String(valueToSearch).toLowerCase().includes(searchTerm.toLowerCase());
      }),
    );
  }

  private static getPropertyValue(object: any, path: string, countries?: Country[]): any {
    return path.split('.').reduce((item, key) => {
      const isArrayMatch = key.match(/^([a-zA-Z0-9_]+)\[(\d+)\]$/);
      let value: any;

      if (isArrayMatch) {
        const arrayKey = isArrayMatch[1];
        const arrayIndex = parseInt(isArrayMatch[2], 10);
        value = item && Array.isArray(item[arrayKey]) ? item[arrayKey][arrayIndex] : null;
      } else {
        value = item && item[key] !== undefined ? item[key] : null;
      }

      // Handle Date formatting
      if (value instanceof Date) {
        value = formatDate(value, 'dd.MM.yyyy', 'de');
      }

      // Handle tripDestinationCountryId lookup
      if (key === 'tripDestinationCountryId' && countries && value !== null) {
        const country = countries.find(country => country?.id === value);
        value = country ? country.name.toLowerCase() : '';
      }

      return value;
    }, object);
  }
}
